import type { GameRow, TeamSide, Venue, VenueBook } from './types';

/** The order form's input, not a new feed or game shape. Existing GameRows
 * remain valid. A standalone binary has one book and no invented opponent,
 * game clock or schedule. */
export type OrderEntryTarget = (GameRow & { market?: never; validateCurrent?: never }) |
  (Pick<GameRow, 'key' | 'sport'> & Partial<GameRow> & {
    market: { venue: Venue; title: string; book: VenueBook };
    /** Re-read source identity at dispatch, including before React flushes. */
    validateCurrent: () => boolean;
  });

export function ticketBook(target: OrderEntryTarget, venue: Venue, side: TeamSide): VenueBook | undefined {
  if (target.market) return target.market.venue === venue ? target.market.book : undefined;
  return (venue === 'kalshi' ? target.kalshi : target.polymarket)?.[side];
}
